export const FLASH_DURATION = 3000
export const DEBOUNCE_DURATION = 1500
export const MAX_CHARACTER_COUNT = 50
